// Copyright (c) 2019 Deere & Company

export const isDealerSettingsValid = accounts => accounts.selectedAccounts.length > 0 || accounts.allowedAccounts.length === 0;



// WEBPACK FOOTER //
// ./src/user/dealer-settings/services/form-validation.js